import { supabase } from '../lib/supabase';

export interface InviteClientResult {
  success: boolean;
  userId?: string;
  error?: string;
}

/**
 * Invite standalone (CompanyAdmin) : sans rattachement à un diagnostic.
 * L'edge function accepte un diagnosticId optionnel.
 */
export async function inviteClient(params: {
  email: string;
  firstName?: string;
  lastName?: string;
}): Promise<InviteClientResult> {
  try {
    const { data, error } = await supabase.functions.invoke('invite-client', {
      body: {
        email: params.email,
        firstName: params.firstName,
        lastName: params.lastName,
        redirectTo: `${window.location.origin}/update-password`,
      },
    });

    if (error) {
      return { success: false, error: error.message };
    }

    if (!data?.success) {
      return { success: false, error: data?.error || "Échec de l'invitation" };
    }

    return { success: true, userId: data.userId };
  } catch (err: any) {
    return { success: false, error: err.message || 'Erreur réseau' };
  }
}

/**
 * Invite un client par email et l'associe à un diagnostic spécifique.
 * Supabase envoie un email avec un lien vers /update-password.
 * L'association client_id ↔ diagnostic se fait lors de la première connexion.
 */
export async function inviteClientToDiagnostic(
  email: string,
  diagnosticId: string
): Promise<InviteClientResult> {
  try {
    const { data, error } = await supabase.functions.invoke('invite-client', {
      body: {
        email,
        diagnosticId,
        redirectTo: `${window.location.origin}/update-password`,
      },
    });

    if (error) {
      return { success: false, error: error.message };
    }

    if (!data?.success) {
      return { success: false, error: data?.error || "Échec de l'invitation" };
    }

    return { success: true, userId: data.userId };
  } catch (err: any) {
    return { success: false, error: err.message || 'Erreur réseau' };
  }
}
